const attachmentFilesEquipmentModelsModal = {
  createTitle: 'Incluir Anexo',
  editTitle: 'Editar Anexo',
  noResults: 'Nenhum resultado encontrado'
};

export default attachmentFilesEquipmentModelsModal;